var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDialogEditor = function SvgDialogEditor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9CC5FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.1313,10.6049v1.138c0,0.6465-0.5269,1.1729-1.1738,1.1729h-3.221v0.0016 c-0.0962,0.0001-0.1924,0.0366-0.2658,0.11l-2.311,2.3105c-0.1465,0.1465-0.1465,0.3848,0,0.5312 c0.0732,0.0732,0.1689,0.1094,0.2651,0.1094s0.1919-0.0371,0.2651-0.1094l2.1689-2.1703h3.0987 c1.0786,0,1.9561-0.8779,1.9561-1.9561v-1.138H10.1313z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.5294,12.9158H1.9712c-0.647,0-1.1738-0.5264-1.1738-1.1729V7.6267c0-0.6475,0.5269-1.1738,1.1738-1.1738 h1.6113V5.6697H1.9712c-1.0786,0-1.9561,0.8779-1.9561,1.957v4.1162c0,1.0781,0.8774,1.9561,1.9561,1.9561h0.5582V12.9158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.0288,0.0214H7.0425c-1.0786,0-1.9561,0.8779-1.9561,1.957v4.1162c0,1.0781,0.8774,1.9561,1.9561,1.9561 h3.0929l2.1785,2.179c0.0732,0.0732,0.1689,0.1094,0.2651,0.1094s0.1919-0.0361,0.2651-0.1094 c0.1465-0.1465,0.1465-0.3848,0-0.5312L10.5263,7.38c-0.0727-0.0727-0.1678-0.1085-0.2631-0.109V7.2675H7.0425 c-0.647,0-1.1738-0.5264-1.1738-1.1729V1.9784c0-0.6475,0.5269-1.1738,1.1738-1.1738h6.9863c0.647,0,1.1738,0.5264,1.1738,1.1738 v4.1162c0,0.6465-0.5269,1.1729-1.1738,1.1729h-0.555v0.7832h0.555c1.0786,0,1.9561-0.8779,1.9561-1.9561V1.9784 C15.9849,0.8993,15.1074,0.0214,14.0288,0.0214z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 8.483,
    cy: 4.0684,
    r: 0.625
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10.5293,
    cy: 4.073,
    r: 0.625
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.5713,
    cy: 4.0759,
    r: 0.625
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDialogEditor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dialog_editor.3a9aca2d8b36425fdaac62f9b794e4b9.svg";